<template>
    <div class="site-selection pa-2 pl-4 mt-1">
        <div class="v-flex">
            <v-text-field
                hide-details
                class          = "mt-0 pt-3 pr-2 mb-3"
                @input         = "onInput"
                @click:append  = "fullsearch=!fullsearch"
                :append-icon   = "fullsearch ? 'fas fa-search-plus' : 'fas fa-search'"
                v-model        = "sitesearch"
                :label         = "fullsearch ? 'Volltextsuche' : 'Fabrik-Nr.'"
                autocomplete   = "off"
                autocorrect    = "off"
                autocapitalize = "off"
                spellcheck     = "false"
            />
        </div>

        <div class="site-selection-content">
            <drag
                v-for="(item, index) in selectable"
                @cut       = "onCut(item)"
                :key       = "item.id"
                :data      = "item"
                type       = "inb-message-selectable"
                @dragstart = "onDragStart"
                @dragend   = "onDragEnd"
            >
                <c-site-selection-card
                    :site  = "item"
                    style  = "width: 300px;"
                    :class = "index < selectable.length-1 ? 'mb-2' : ''"
                />
            </drag>
        </div>
    </div>
</template>

<script>

import Site from "@/modules/msd/unit/service/Site";
import { Drag, } from "vue-easy-dnd";
import CSiteSelectionCard from "@/modules/msd/unit/components/controlls/CSiteSelectionCard.vue";

export default {
    name: "CSiteSelection",

    components: {
        CSiteSelectionCard,
        Drag,
    },

    props: {
        customer: {
            required: true,
            type    : Object,
        },

        forceAllUnits: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        maxHeight: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        fullsearch: false,
        sitesearch: "",
        selectable: [],
        height    : null
    }),

    computed: {
    },

    methods: {
        onInput () {
            if (this.sitesearch.length === 0) {
                this.selectable = [];
                return;
            }

            if (this.fullsearch) {
                this.searchFull(this.sitesearch);
            } else {
                this.search(this.sitesearch)
            }
        },

        onCut (unit) {
            this.$emit("cut", unit);
        },

        onDragStart () {
            this.$emit("dragging", true)
        },

        onDragEnd () {
            this.$emit("dragging", false)
        },

        search (value) {
            const filter = !this.forceAllUnits ? null : {
                onlyLiftmanagement: false
            }

            Site.search(this.customer.id, value, false, filter).then((data) => {
                this.selectable = data;
            });
        },

        searchFull (value) {
            const filter = !this.forceAllUnits ? null : {
                onlyLiftmanagement: false
            }

            Site.search(this.customer.id, value, true, filter).then((data) => {
                this.selectable = data;
            });
        },
    }
}
</script>

<style scoped>

.site-selection {
    height: 650px;
    background-color: white;
    border-radius: 5px;
    width: 330px;
}

.site-selection-content {
    max-height: calc(100% - 60px);
    overflow-y: scroll;
    padding-right: 5px;
    padding-left: 0;
    width: calc(100% + 4px)
}

</style>
